import { fetchAuthSession } from '@aws-amplify/auth';
import { WHISPERBI_SECURITY_API } from '../env';

// Whitelist de correos exactos que pueden registrarse aunque su dominio sea
// público (gmail, etc.). Backend: functions/security-roles/app.py
// (/security/signup-allowlist), CRUD solo para el grupo Cognito `root`.
const ALLOWLIST_URL = `${WHISPERBI_SECURITY_API}/security/signup-allowlist`;

async function getIdToken() {
  try {
    const tokens = (await fetchAuthSession()).tokens;
    return tokens?.idToken?.toString() || null;
  } catch (error) {
    console.error('SignupAllowlistService.getIdToken: unable to fetch auth session', error);
    return null;
  }
}

async function request(url, options = {}) {
  const init = { ...options };
  const headers = new Headers(init.headers || {});

  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const token = await getIdToken();
  if (!token) {
    throw new Error('No se encontró un token de autenticación para realizar la operación solicitada.');
  }
  headers.set('Authorization', `Bearer ${token}`);

  init.headers = headers;
  init.mode = init.mode || 'cors';
  init.cache = init.cache || 'no-cache';

  let response;
  try {
    response = await fetch(url, init);
  } catch (networkError) {
    console.error('SignupAllowlistService.request: network error', networkError);
    throw new Error('No se pudo conectar con el servicio. Verifica tu conexión o intenta más tarde.');
  }

  if (!response.ok) {
    let errorMessage = `HTTP ${response.status}`;
    try {
      const data = await response.json();
      const backendMessage = data?.message || data?.error || data?.errorMessage;
      if (backendMessage) {
        errorMessage = backendMessage;
      }
    } catch {
      const text = await response.text().catch(() => '');
      if (text) {
        errorMessage = text;
      }
    }
    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get('content-type') || '';
  return contentType.includes('application/json') ? response.json() : response.text();
}

export async function listSignupAllowlist() {
  return request(ALLOWLIST_URL, { method: 'GET' });
}

export async function addSignupAllowlistEntry({ email, note } = {}) {
  if (!email || !email.trim()) {
    throw new Error('El correo es obligatorio.');
  }
  return request(ALLOWLIST_URL, {
    method: 'POST',
    body: JSON.stringify({ email: email.trim(), note: (note || '').trim() })
  });
}

export async function removeSignupAllowlistEntry(email) {
  if (!email) {
    throw new Error('Se requiere el correo para eliminarlo de la lista.');
  }
  return request(`${ALLOWLIST_URL}/${encodeURIComponent(email)}`, { method: 'DELETE' });
}

const SignupAllowlistService = {
  listSignupAllowlist,
  addSignupAllowlistEntry,
  removeSignupAllowlistEntry
};

export default SignupAllowlistService;
